module.exports = __webpack_public_path__ + "static/img/dashuju1.3d98631.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashuju1.png
// module id = gWg3
// module chunks = 52